import { PageTitle } from "@/components/page-title";
import { CounterpartyForm } from "./_form";
import { Counterparty, PropsWithUser } from "@/types";

type Props = {
  counterparty: Counterparty;
};

function CounterpartyShow({ counterparty }: PropsWithUser<Props>) {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <PageTitle>Edit counterparty</PageTitle>
      <CounterpartyForm counterparty={counterparty} />
    </div>
  );
}

export default CounterpartyShow;
